import React, { useEffect, useState } from 'react';
import { motion } from 'framer-motion';
import { useInView } from 'react-intersection-observer';
import { TrendingUpIcon, TrendingDownIcon } from 'lucide-react';
interface MarketData {
  symbol: string;
  price: number;
  change: number;
  changePercent: number;
}
const initialMarketData: MarketData[] = [{
  symbol: 'SPX',
  price: 6791.69,
  change: 0,
  changePercent: 0
}, {
  symbol: 'NDX',
  price: 21532.45,
  change: 0,
  changePercent: 0
}, {
  symbol: 'DJI',
  price: 43910.98,
  change: 0,
  changePercent: 0
}, {
  symbol: 'BTC',
  price: 106234.5,
  change: 0,
  changePercent: 0
}, {
  symbol: 'ETH',
  price: 3987.23,
  change: 0,
  changePercent: 0
}, {
  symbol: 'GOLD',
  price: 4076.12,
  change: 0,
  changePercent: 0
}];
export function LiveMarketData() {
  const [ref, inView] = useInView({
    triggerOnce: true,
    threshold: 0.1
  });
  const [marketData, setMarketData] = useState(initialMarketData);
  useEffect(() => {
    const interval = setInterval(() => {
      setMarketData(prevData => prevData.map(item => {
        const changePercent = (Math.random() - 0.5) * 0.5;
        const change = item.price * changePercent / 100;
        const newPrice = item.price + change;
        return {
          ...item,
          price: Number(newPrice.toFixed(2)),
          change: Number(change.toFixed(2)),
          changePercent: Number(changePercent.toFixed(2))
        };
      }));
    }, 2000);
    return () => clearInterval(interval);
  }, []);
  return <section ref={ref} className="w-full py-32 px-6 bg-navy-900" data-id="element-135">
      <div className="max-w-6xl mx-auto" data-id="element-136">
        <motion.h2 initial={{
        opacity: 0,
        y: 20
      }} animate={inView ? {
        opacity: 1,
        y: 0
      } : {}} transition={{
        duration: 0.6
      }} className="text-4xl md:text-5xl font-bold mb-12 text-center text-white" data-id="element-137">
          Live Market Data
        </motion.h2>
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={inView ? {
        opacity: 1,
        y: 0
      } : {}} transition={{
        duration: 0.6,
        delay: 0.2
      }} className="grid md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-138">
          {marketData.map((item, index) => <motion.div key={item.symbol} initial={{
          opacity: 0,
          scale: 0.9
        }} animate={inView ? {
          opacity: 1,
          scale: 1
        } : {}} transition={{
          duration: 0.5,
          delay: 0.1 * index
        }} whileHover={{
          scale: 1.05,
          y: -8
        }} className="bg-navy-800 border-2 border-navy-700 rounded-lg p-6 hover:border-steel transition-all duration-300 shadow-lg" data-id="element-139">
              <div className="flex items-center justify-between mb-4" data-id="element-140">
                <h3 className="text-2xl font-bold text-white" data-id="element-141">{item.symbol}</h3>
                {item.changePercent >= 0 ? <TrendingUpIcon className="w-6 h-6 text-[#10B981]" data-id="element-142" /> : <TrendingDownIcon className="w-6 h-6 text-[#EF4444]" data-id="element-143" />}
              </div>
              <motion.div key={item.price} initial={{
            scale: 1
          }} animate={{
            scale: [1, 1.1, 1]
          }} transition={{
            duration: 0.3
          }} data-id="element-144">
                <p className="text-3xl font-bold text-white mb-2" data-id="element-145">
                  ${item.price.toLocaleString()}
                </p>
              </motion.div>
              <motion.div className="flex items-center gap-2" animate={{
            color: item.changePercent >= 0 ? '#10B981' : '#EF4444'
          }} data-id="element-146">
                <span className="font-semibold" data-id="element-147">
                  {item.changePercent >= 0 ? '+' : ''}
                  {item.change.toFixed(2)}
                </span>
                <span className="text-sm" data-id="element-148">
                  ({item.changePercent >= 0 ? '+' : ''}
                  {item.changePercent.toFixed(2)}%)
                </span>
              </motion.div>
            </motion.div>)}
        </motion.div>
        <motion.p initial={{
        opacity: 0
      }} animate={inView ? {
        opacity: 1
      } : {}} transition={{
        duration: 0.6,
        delay: 1
      }} className="text-center text-slate text-sm mt-8" data-id="element-149">
          Simulated data for demonstration purposes only. Updates every 2
          seconds.
        </motion.p>
      </div>
    </section>;
}